<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">View Drawings</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <aims-common-table
        id="drawings-table"
        [dataSource]="drawings | async"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        [defaultTableState] = "{ sort:{ active : 'cadDrawingId', direction: 'asc' }}"
        pageSize="10"
        [stickyHeader]="true">

        <aims-common-table-dynamic-row id="drawingStatusName">
          <ng-template viewMode let-element >
             {{ element.drawingStatusName }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let s of statusValues | async" [value]="s.drawingStatusName">
                  {{ s.drawingStatusName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="drawingFormatName">
          <ng-template viewMode let-element >
             {{ element.drawingFormatName }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let f of formatValues | async" [value]="f.drawingFormatName">
                  {{ f.drawingFormatName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="siteName">
          <ng-template viewMode let-element >
             {{ element.siteName }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let s of sitesValues" [value]="s.siteName">
                  {{ s.siteName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="discipline">
          <ng-template viewMode let-element >
             {{ element.discipline }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let d of disciplineValues | async" [value]="d.discipline">
                  {{ d.discipline }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="assignedDrafter">
          <ng-template viewMode let-element >
             {{ element.assignedDrafter }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of employeeValues" [value]="e.fullName">
                  {{ e.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="reviewedBy">
          <ng-template viewMode let-element >
             {{ element.reviewedBy }}
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of employeeValues" [value]="e.fullName">
                  {{ e.fullName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

      </aims-common-table>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
